import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { AppRoutingModule } from './../../app-routing.module';

@Component({
	// moduleId: module.id,
    selector: 'app-account-layout',
	templateUrl: "./accountlayout.component.html",
	styleUrls: ['./accountlayout.component.scss']
})
export class AccountLayout implements OnInit {

	constructor() {
	}

	ngOnInit(): void {
	}
}